/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_6_ResultInputs */

const et_portfolio_project_6_result = /** @type {(inputs: Portfolio_Project_6_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaasatus kasvas 35% ja päringud 20% 3 kuu jooksul.`)
};

const en_portfolio_project_6_result = /** @type {(inputs: Portfolio_Project_6_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increased engagement by 35% and generated 20% more leads in 3 months.`)
};

/**
* | output |
* | --- |
* | "Increased engagement by 35% and generated 20% more leads in 3 months." |
*
* @param {Portfolio_Project_6_ResultInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_6_result = /** @type {((inputs?: Portfolio_Project_6_ResultInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_6_ResultInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_6_result(inputs)
	return en_portfolio_project_6_result(inputs)
});